import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {AccountInterfaceData, AccountInterfacePostData } from '../shared/models/account.model';

import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AccountsService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  post(endpoint: string, account: AccountInterfaceData) {
    return this.http.post(`${this.url}/${endpoint}`, account,{observe: 'response'});
  }

  getAccounts(endpoint: string){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.get< AccountInterfaceData[]>(url);
    // {observe: 'response'} main.js:1 ERROR TypeError: t.payload is not iterable
  } //end login

  get(endpoint: string){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.get< AccountInterfaceData>(url,{observe: 'response'});
  } //end login

  put(endpoint: string, account){
    //{ headers: headers, params: params }
    let url = `${this.url}/${endpoint}`;
    return this.http.put<AccountInterfaceData>(url,account,{observe: 'response'});
  } //end login

  delete(endpoint: string){
    //{ headers: headers, params: params }
    const url = `${this.url}/${endpoint}`;
    console.log('OMG!!!!!!!!', url);
    return this.http.delete(url,{observe: 'response'});
  } //end login

} //
